let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("52MFn")).then(() => parcelRequire('cpvBW'));